var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCashAndRemittances = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Email-Action-Cash--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Email Action Cash Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.12 13a0.25 0.25 0 0 0 0.25 0 0.24 0.24 0 0 0 0.14 -0.22V2.25a0.29 0.29 0 0 1 0.07 -0.18 0.29 0.29 0 0 1 0.17 -0.07h12.5a0.25 0.25 0 0 1 0.25 0.25v10.57a0.24 0.24 0 0 0 0.13 0.22 0.24 0.24 0 0 0 0.26 0L23 10.43a0.25 0.25 0 0 0 0.11 -0.21A0.28 0.28 0 0 0 23 10l-2.5 -1.7V2.21a2.11 2.11 0 0 0 -2 -2.21h-13a2.12 2.12 0 0 0 -2 2.21V8.3L1 10a0.28 0.28 0 0 0 -0.1 0.21 0.26 0.26 0 0 0 0.11 0.21Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.41 15.13a0.73 0.73 0 0 1 -0.41 0.12H6a0.72 0.72 0 0 1 -0.4 -0.12L0.39 11.78a0.27 0.27 0 0 0 -0.26 0A0.26 0.26 0 0 0 0 12v10a2 2 0 0 0 2 2h20a2 2 0 0 0 2 -2V12a0.26 0.26 0 0 0 -0.13 -0.22 0.27 0.27 0 0 0 -0.26 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38 6.59a2.07 2.07 0 0 0 1.31 1.94l2.06 0.83a0.58 0.58 0 0 1 0.37 0.55 0.59 0.59 0 0 1 -0.59 0.59h-2a0.75 0.75 0 0 0 0 1.5h0.75v0.5a0.75 0.75 0 0 0 1.5 0V12a2.09 2.09 0 0 0 0.56 -4l-2.06 -0.83a0.58 0.58 0 0 1 -0.37 -0.55 0.59 0.59 0 0 1 0.56 -0.62h2a0.75 0.75 0 0 0 0 -1.5h-0.75V4a0.75 0.75 0 0 0 -1.5 0v0.52a2.08 2.08 0 0 0 -1.84 2.07Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCashAndRemittances);
export default ForwardRef;